
<div class="container" style="margin-top: 60px;">
    <div class="row pt15 pb13">
      <div class="col-lg-5 col-md-12 first-ldiv">
        <img src="./assets/Group 27@1X.png">
        <h2>Your playground where you play with locations, rates, numbers at your terms and your rules.
        </h2>
      </div> 
      <div class="col-lg-6 offset-lg-1 col-md-12 first-rdiv">
        <h4>Why we created it.</h4>
        <p>Adventumcalculators.com sole focus is to provide fast, comprehensive, convenient, free online calculators in a plethora of areas for property investments in UK.</p>
        <p>Currently, we have around 5 calculators which help you "do the math" quickly in areas such as property Investments, capital growth, rent, stamp duty and forex exchange. </p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-5 col-md-12 first-rdiv cal-head">
       <h4>Foreign Buyer Property Investment Calculator</h4>
     </div> 
     <div class="col-lg-6 offset-lg-1 col-md-12 first-rdiv">
  
      <p style="padding-top:0px;">As a foreign investor, calculate 3-dimensional returns in tandem from rent, foreign exchange gains and capital growth on your property in UK. Play with your assumptions and optimise investment strategies. </p>
    </div>
  </div>
    <div class="row">
      <div class="col-lg-5 col-md-12 first-rdiv cal-head">
       <h4>Capital Growth Calculator</h4>
     </div> 
     <div class="col-lg-6 offset-lg-1 col-md-12 first-rdiv">
  
      <p style="padding-top:0px;">A simple Capital Growth Calculator to see the future value of your property. Play with your growth assumptions and optimise strategies on your properties in the UK. </p>
    </div>
  </div>
    <div class="row">
      <div class="col-lg-5 col-md-12 first-rdiv cal-head">
       <h4>Estimated Weekly Rent Calculator</h4>
     </div> 
     <div class="col-lg-6 offset-lg-1 col-md-12 first-rdiv">    <p style="padding-top:0px;">Use this calculator to quickly check and compare rents in UK by the week in a 52 week year. Play with your assumptions to optimise and achieve rental yield that is in line with the market. </p>
    </div>
  </div>
    <div class="row">
      <div class="col-lg-5 col-md-12 first-rdiv cal-head">
       <h4>Foreign Exchange Calculator</h4>
     </div> 
     <div class="col-lg-6 offset-lg-1 col-md-12 first-rdiv">    
      <p style="padding-top:0px;">Play with your assumptions on the Foreign Exchange impact on your overseas investment. Calculations are supported with real-time data to support your assumptions from XE.</p>
    </div>
  </div>
    <div class="row">
      <div class="col-lg-5 col-md-12 first-rdiv cal-head">
       <h4>Stamp Duty Calculator</h4>
     </div> 
     <div class="col-lg-6 offset-lg-1 col-md-12 first-rdiv">    
      <p style="padding-top:0px;">Calculate the exact cost of stamp duty on your property purchase as it varies in the UK with the price of the property and the kind of the buyer: First-time, Investor, Corporate, Foreign and more.</p>
    </div>
  </div>
  

  
</div>
<div class="bg-grey">
  <div class="container">
    <!--second div-->
    <div class="row pt8 ">
      <div class="col-lg-9 col-md-12 second-ldiv">
        <h5>The Creaters</h5>
        <h2>The calculators are created by Adventum Wealth,<br class="hidden-xs" />
          a pioneer in offshoring UHNI/HNI Wealth to global <br class="hidden-xs" />
        property markets since 2015.</h2>
      </div>
    </div>

    <!-- <div class="row">
      <div class=" col-lg-12 col-md-12">
        <div class="row pt5">
          <div class="col-md-6 second-rdiv">
            <h4>Offshore Advisory</h4>
            <p>Adventum Offshore strategizes capital export, optimizes holding structures, secures leverage and steps in to manage the UK property on behalf of its overseas clients as a 360-degree advisory.</p>
          </div>
          <div class="col-md-6 second-rdiv">
            <h4>Passport</h4>
            <p>An overseas permanent residency or second citizenship are topics of significance among internationally mobile entrepreneurs. consult with Adventum Passport on available options to make tax efficiency and visa-free travel a reality for you!</p>
          </div>
        </div>

        <div class="row pt5">
          <div class="col-md-6 second-rdiv">
            <h4>Analytics</h4>
            <p>Housed on a machine learning technology platform driven by highly experienced investment bankers and data science professionals, Adventum Analytics enables better data for better decisions to invest in UK Property. </p>
          </div>

          <div class="col-md-6 second-rdiv">
            <h4>Furnishing & Home-Staging</h4>
            <p>In partnership with David Phillips, we offer furniture that is both practical and aesthetic to maximize rental yields to achieve the true potential of your investment by transforming your property into a wonderful home.</p>
         </div>

       </div>
     </div>
  </div> -->
</div>
</div>
  